import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import API_BASE from '../../../apiConfig';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!email.trim()) {
      setError('Please enter your email address');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${API_BASE}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.detail || 'Something went wrong');
      }

      setSuccess(data.message || 'If this email is registered, you will receive a password reset link shortly.');
      setEmail('');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-split-container">
        {/* Left Side: Branding */}
        <div className="login-hero-section">
          <div className="login-hero-content">
            <div className="logo-badge">ForeC.AI</div>
            <h2>Next Generation <br/>Supply Chain Intelligence</h2>
            <p>Empowering your organization with prescriptive analytics, scenario modeling, and predictive insights.</p>
            
            <div className="hero-floating-elements">
              <div className="float-card card-1">
                <span>Forecast Accuracy</span>
                <strong>+24%</strong>
              </div>
              <div className="float-card card-2">
                <span>Optimization</span>
                <strong>Real-time</strong>
              </div>
            </div>
          </div>
          <div className="hero-overlay"></div>
        </div>

        {/* Right Side: Forgot Password Form */}
        <div className="login-form-section">
          <div className="login-form-container">
            <div className="login-header">
              <h1 className="login-title">Forgot Password</h1>
              <p className="login-subtitle">Enter your email to receive a reset link</p>
            </div>
            
            {error && (
              <div className="login-error-alert animate-shake">
                <span className="alert-icon">!</span>
                <span className="alert-message">{error}</span>
              </div>
            )}

            {success && (
              <div className="forgot-success-alert">
                <span className="alert-icon">✓</span>
                <span className="alert-message">{success}</span>
              </div>
            )}

            {!success && (
              <form className="login-form" onSubmit={handleSubmit}>
                <div className="input-group">
                  <label htmlFor="email">Email Address</label>
                  <div className="input-with-icon">
                    <span className="input-icon">✉</span>
                    <input
                      id="email"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="e.g. john@company.com"
                      autoComplete="email"
                      required
                    />
                  </div>
                </div>

                <button 
                  type="submit" 
                  className={`btn-primary login-btn ${loading ? 'loading' : ''}`}
                  disabled={loading}
                >
                  {loading ? (
                    <span className="spinner"></span>
                  ) : (
                    <>
                      <span>Send Reset Link</span>
                      <span className="btn-icon">→</span>
                    </>
                  )}
                </button>
              </form>
            )}

            <div className="auth-footer-link">
              <Link to="/login">← Back to Sign In</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
